import * as React from 'react';
import ReactSlider from 'react-slider';
import styled, { css } from 'react-emotion';
import UIButton from '@jetshop/ui/Button/Button';
import t from '@jetshop/intl';
const RangeSliderContainer = styled('div') `
  width: 100%;
  padding: 1rem;
  background: #f7f7f7;
  z-index: 5;
  border: 1px solid #dedede;
  border-top: 0;

  .slider {
    height: 1rem;
  }

  .slider.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  .bar {
    height: 1rem;
    background: transparent;
    padding-bottom: 1rem;
    &:after {
      height: 2px;
      width: 100%;
      position: absolute;
      top: 7px;
      background: silver;
      content: '';
    }
    &-1:after {
      /* The active bar section */
      background: black;
    }
  }
  .handle {
    height: 1rem;
    width: 1rem;
    background: black;
  }
`;
const Values = styled('div') `
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
`;
const Submit = styled(UIButton) `
  margin-top: 1rem;
  max-width: 100%;
`;
export default class RangeFilter extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.defaultVal || [this.props.min, this.props.max],
            showReset: !!this.props.defaultVal
        };
        this.updateValue = (value) => {
            this.setState({
                value,
                showReset: false
            });
        };
        this.applyAndClose = () => {
            const [min, max] = this.state.value;
            // Apply the range filter using the method passed via context
            this.props.applyRangeFilter(this.props.id, min, max);
            if (min !== this.props.min || max !== this.props.max) {
                this.setState({ showReset: true });
            }
            // Call our optional callback
            this.props.onSubmit && this.props.onSubmit();
        };
        this.reset = () => {
            const { min, max } = this.props;
            this.props.applyRangeFilter(this.props.id, min, max);
            this.setState({ showReset: false, value: [min, max] });
        };
        this.hasActiveSelections = () => {
            const { min, max } = this.props;
            const [lowerLimit, upperLimit] = this.state.value;
            return min !== lowerLimit || max !== upperLimit;
        };
    }
    render() {
        const { min, max } = this.props;
        const [lowerLimit, upperLimit] = this.state.value;
        return (React.createElement(RangeFilter.RangeSliderContainer, { className: this.props.className },
            React.createElement(Values, null,
                React.createElement("span", null, lowerLimit),
                React.createElement("span", null, upperLimit)),
            React.createElement(ReactSlider, { disabled: min === max, min: min, max: max, minDistance: 10, defaultValue: this.props.defaultVal || [min, max], onChange: val => this.updateValue(val), value: [lowerLimit, upperLimit], withBars: true }),
            React.createElement(Submit, { onClick: this.state.showReset ? this.reset : this.applyAndClose, className: min === max &&
                    css `
              opacity: 0.3;
              pointer-events: none;
            ` }, t(this.state.showReset ? 'Reset' : 'Apply'))));
    }
}
RangeFilter.RangeSliderContainer = RangeSliderContainer;
//# sourceMappingURL=RangeFilter.js.map